// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AssetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AssetIcon" ref={forwardedRef} {...props}>
      <path d="M4.838 6.754h2.024L6.964 5H5.57zM6.862 8H4.838l4.059 6.763zM3 8l2-4.5h10L17 8l-6.387 8.947a.75.75 0 0 1-1.22 0zm12.156 0H13.14l-1.999 6.763zm-3.574 0H8.42l1.584 7.415zm0-1.246L11.534 5H8.47L8.322 6.754zm1.557 0H15L14.336 5H13.04z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AssetIcon = /* @__PURE__ */ Object.assign(AssetIconComponent, {
  displayName: 'AssetIcon',
});
